/**
 * Local Storage Rechner by Andrey Tikhomirov
 * Update: check for string undefined!
 */
(function() {
    window.window.c24StorageDisabled = false; // set true to disable the local storage
    window.c24StoragePid = 'pkw3'; // set to pkw3 for the new storage

    window.c24Lp.logDebug('Localstorage : ' + (window.c24StorageDisabled ? 'disabled' : 'enabled'));

    window.c24GetStorage = function(pid) {
        let storage = false;
        let pages;
        let pagesSeen = 0;
        let hoursDiff;
        const now = new Date();
        const hoursStorageValid = 2160;

        let resultsInfoTime = 0;
        let localStorageTime = 0;
        let resultsInfo = false;

        if (window.c24StorageDisabled) {
            return storage;
        }

        // does the auto pid detection
        pid = c24StorageCheckPid(pid);

        const localStorageNew = convertJson(window.c24LocalStorageGet(pid + 'lpls'));

        window.c24Lp.logDebug('Localstorage : ' + (localStorageNew ? '' : 'not ') + 'using new style storage');

        // Fast formats the date
        function fastFormat(date, withTime) {
            if (!isNaN(date.getTime())) {
                let datestring = date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
                if (withTime) {
                    datestring += ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
                }
                return datestring;
            } else {
                return '';
            }
        }

        // Fast formats the date
        function getStamp(date) {
            if (!isNaN(date.getTime())) {
                return date.getTime();
            } else {
                return '';
            }
        }

        // Escape fishy chars
        function escapeString(string) {
            if (string == null) {
                return null;
            }
            return string.replace(/[&#'":*?<>{}]/g, '');
        }

        function setTimeToStorage(date) {
            storage.updated = !date ? '' : fastFormat(date);
            storage.fulldate = !date ? '' : fastFormat(date, true);
            storage.timestamp = !date ? '' : getStamp(date);
        }

        // Gets the local storage
        function getLocalStorage() {
            let data = {};

            data.vehicle = escapeString(window.c24LocalStorageGet(pid + 'vehicle.vehicleDescription'));

            if (!localStorageNew && data.vehicle == null) {
                return false;
            }

            data.vehicleAlternative = escapeString(window.c24LocalStorageGet(pid + 'vehicle.vehicleDescriptionAlternative'));
            data.verkaufsbezeichnung = escapeString(window.c24LocalStorageGet(pid + 'vehicle.verkaufsbezeichnung'));

            // Adjust the vehicle for MOT
            if (pid == 'mot' && data.vehicle && data.vehicle.indexOf(',') > 0) {
                data.vehicle = data.vehicle.substring(0, data.vehicle.indexOf(','));
            }

            pages = window.c24LocalStorageGet(pid + 'visitedPages');

            // pagesSeen = last page in the dialog
            pagesSeen = pages == null ? 0 : JSON.parse(pages).length;
            pagesSeen = pagesSeen > 4 ? 4 : pagesSeen;
            data.pagesSeen = pagesSeen;

            hoursDiff = (now - localStorageTime.getTime()) / 1000 / 3600;
            if (hoursDiff > hoursStorageValid) {
                return false;
            }

            if (localStorageNew) {
                data = localStorageNew;

            } else if (pid == 'pkw2') {
                data.url = '/einsurance/doEntry.form?lwls=true';
                data.json = window.c24LocalStorageGet('vehicle');

            } else if (pid == 'pkw3') {
                data.url = '/einsurance/pkw/doEntry.form?lwls=true';
                // storage.json = window.c24LocalStorageGet('pkw3storageData');
                data.hsn = escapeString(window.c24LocalStorageGet('pkw3vehicleSearch.hsn'));
                data.tsn = escapeString(window.c24LocalStorageGet('pkw3vehicleSearch.tsn'));

            } else if (pid == 'mot') {
                data.url = '/einsurance/mot/motEntry.form?lwls=true';
                data.json = window.c24LocalStorageGet('motVehicle');
            }

            storage = data;

            setTimeToStorage(localStorageTime);
        }

        // Gets result info
        function getResultsInfo() {
            const data = {};
            data.type = 'results';
            data.hsn = escapeString(resultsInfo.hsn);
            data.tsn = escapeString(resultsInfo.tsn);
            data.url = resultsInfo.entryLink;
            data.vehicle = escapeString(resultsInfo.kfzDescription);
            data.amount = resultsInfo.minPrice;
            data.paymentPrefix = resultsInfo.zahlweise;
            data.anzahl = resultsInfo.count;

            storage = data;
            setTimeToStorage(resultsInfoTime);
        }

        function convertJson(sJson) {
            try {
                return JSON.parse(sJson);
            }
            catch (e) {
                console.log(e);
            }
            return null;
        }

        // Check if localStorage is set
        try {
            if (window.localStorage != null) {
            // Is there a results info?
                resultsInfo = convertJson(window.c24LocalStorageGet(pid + 'resultInfos'));

                if (resultsInfo) {
                    resultsInfoTime = new Date(resultsInfo.timestamp);
                }

                // Is there a regular local storage?
                const localStorageUpdated = localStorageNew && localStorageNew.timestamp ? localStorageNew.timestamp : window.c24LocalStorageGet(pid + 'session.latestUpdate');

                if (localStorageUpdated) {
                    localStorageTime = new Date(localStorageUpdated);
                }

                if (!localStorageTime && !resultsInfoTime) {
                    return false;
                }

                if (resultsInfoTime > localStorageTime) {
                    getResultsInfo();
                } else {
                    getLocalStorage();
                }
            }
        } catch (e) { console.log(e); }

        return storage;
    };

    /**
     * Check if Local Storage is Active
     */
    window.c24CheckStorage = function(pid) {
        if (window.c24StorageDisabled) {
            return false;
        }

        pid = c24StorageCheckPid(pid);

        try {
            if (
                window.localStorage != null &&
            (
                (localStorage.getItem(pid + 'vehicle.vehicleDescription') && localStorage.getItem(pid + 'session.latestUpdate')) ||
                localStorage.getItem(pid + 'resultInfos') ||
                localStorage.getItem(pid + 'lpls')
            )
            ) {
                return true;
            }
        } catch (e) { console.log(e); }

        return false;
    };

    /**
     * Clear the Storage
     */
    window.c24ClearStorage = function(pid) {
    // Check if localStorage is set
        if (pid) {
            if (window.localStorage != null) {
                window.c24LocalStorageRemove(pid + 'vehicle.vehicleDescription');
                window.c24LocalStorageRemove(pid + 'vehicle.vehicleDescriptionAlternative');
                window.c24LocalStorageRemove(pid + 'vehicle.verkaufsbezeichnung');
                window.c24LocalStorageRemove(pid + 'visitedPages');
                window.c24LocalStorageRemove(pid + 'storageData');
                window.c24LocalStorageRemove(pid + 'vehicleSearch.hsn');
                window.c24LocalStorageRemove(pid + 'vehicleSearch.tsn');

                window.c24LocalStorageRemove(pid + 'lpls');
                window.c24LocalStorageRemove(pid + 'resultInfos');

                if (pid == 'pkw2') {
                    window.c24LocalStorageRemove('vehicle');
                    window.c24LocalStorageRemove('drivers');
                    window.c24LocalStorageRemove('protection');
                    window.c24LocalStorageRemove('rebates');

                } else if (pid == 'mot') {
                    window.c24LocalStorageRemove('motVehicle');
                    window.c24LocalStorageRemove('motDrivers');
                    window.c24LocalStorageRemove('motProtection');
                    window.c24LocalStorageRemove('motRebates');
                }

                // Sets the session Storage Flag
                window.c24LocalStorageSet(pid + 'forceClearStorage', true);

                return true;
            }
        }
        return false;
    };

    // returns the correct pid
    let c24StorageLastPid = '';
    function c24StorageCheckPid(pid) {
        if (pid === 'autopkw' && window.c24StoragePid) {
            pid = window.c24StoragePid;
        }
        if (pid != c24StorageLastPid) {
            c24StorageLastPid = pid;
            window.c24Lp.logDebug('Localstorage : Set pid ID to ' + pid);
        }
        return pid;
    }
})();
